import axios from "axios";
import React, { useState } from "react";
import { Container } from "semantic-ui-react";
import Footer from "../../common/Footer";
import Logo from "../../common/Logo";
import SummaryPage from "./SummaryPage";
import FormPage from "./FormPage";

const ENV = !process.env.NODE_ENV || process.env.NODE_ENV === "development" ? "development" : "production";

const title = "Dyrektor e-Commerce Roku 2021";

export const TERMS_AND_CONDITIONS = "";

export const Page = {
    Form: "form",
    Summary: "summary",
};

export const ECommerceDirectorApp = () => {
    const [page, setPage] = useState(Page.Form);
    const [token, setToken] = useState(undefined);

    const submit = (form) => {
        const url =
            ENV === "development"
                ? "http://localhost:3000/api/v4/solutions/eizba/ecommerce-director"
                : "https://api.mobileinstitute.eu/api/v4/solutions/eizba/ecommerce-director";

        const formData = new FormData();
        form.submissions.forEach((s) => formData.append(`submissions.${s.key}`, s.presentation));
        formData.append("logo.raster", form.logo.raster);
        formData.append("logo.vector", form.logo.vector);
        formData.append("data", JSON.stringify(form));

        // const config = {
        //   headers: {
        //     "Content-Type": "multipart/form-data"
        //   }
        // };
        axios.post(url, formData).then((resp) => {
            setToken(resp.data);
            setPage(Page.Summary);
        });

        // todo: handle error

        // todo: post form
    };

    const providePage = () => {
        switch (page) {
            case Page.Form:
                return (
                    <FormPage
                        onSubmit={submit}
                        termsAndConditions="http://dyrektorecommerceroku.pl/wp-content/uploads/2020/05/Regulamin-konkursu-Dyrektor-e-Commerce-Roku-2020_FINAL.pdf"
                    />
                );
            case Page.Summary:
                return <SummaryPage token={token} title={title} />;
            default:
                return null;
        }
    };

    return (
        <div className={`panel ${page}`}>
            <Container text>
                <Logo />
                {providePage()}
                <Footer subject={title} />
            </Container>
        </div>
    );
};

export default ECommerceDirectorApp;
